export default function Excel_Certificate() {
  return <div>Excel_Certificate</div>;
}
